import { Injectable } from '@angular/core'

import { EmployeeContractManagerLink } from './employee-contract-manager-link'

@Injectable()
export class EmployeeContractManagerLinkSerializer {
  fromJson(json: any): EmployeeContractManagerLink {
    const employeeContractManagerLink = {
      ...json
    }

    return employeeContractManagerLink
  }

  toJson(employeeContractManagerLink: EmployeeContractManagerLink): any {
    return {
      ...employeeContractManagerLink
    }
  }
}
